<template>
  <div class="asset-register">
    <van-nav-bar title="往期资产" left-arrow @click-left="goHome" />

    <div class="form-box">
      <div class="form-item">
        <span class="label">姓名：</span>
        <span v-if="submitted" class="value">{{ form.name }}</span>
        <input
          v-else
          v-model.trim="form.name"
          type="text"
          maxlength="20"
          placeholder="请输入姓名"
        />
      </div>

      <div class="form-item">
        <span class="label">身份证号码：</span>
        <span v-if="submitted" class="value">{{ form.id_card }}</span>
        <input
          v-else
          v-model.trim="form.id_card"
          type="text"
          maxlength="18"
          placeholder="请输入身份证号码"
        />
      </div>

      <div class="form-item">
        <span class="label">中国制造资产：</span>
        <span v-if="submitted" class="value">{{ formatAmount(form.made_asset) }} 元</span>
        <template v-else>
          <input
            v-model="form.made_asset"
            type="number"
            max="1000000000"
            placeholder="请输入中国制造资产金额"
          />
          <span class="unit">元</span>
        </template>
      </div>

      <div class="form-item">
        <span class="label">中华云泊资产：</span>
        <span v-if="submitted" class="value">{{ formatAmount(form.yunbo_asset) }} 元</span>
        <template v-else>
          <input
            v-model="form.yunbo_asset"
            type="number"
            max="1000000000"
            placeholder="请输入中华云泊资产金额"
          />
          <span class="unit">元</span>
        </template>
      </div>

      <van-button
        v-if="submitted"
        class="submit-btn submit-btn--status"
        disabled
      >
        {{ statusText }}
      </van-button>
      <van-button
        v-else
        class="submit-btn"
        :loading="loading"
        :disabled="loading"
        @click="submit"
      >
        激活并确定资产审核
      </van-button>
    </div>

    <div class="notice">
      <div class="notice-title">ⓘ 注：</div>
      <p>
        本次申报登记的资产为用户个人往期历史资产。平台现已启动点对点精准统计计划，以上历史资产相关档案均会根据申报信息进行审核。审核工作将结合系统登记数据及相关记录，对申报信息进行严格核对。待审核完成并确认无误后，符合条件的往期资产将进入后续拨付流程。
      </p>
      <p>
        请用户认真核对并如实填写相关信息。审核及后续拨付将严格按照既定流程规范有序进行，确保全过程公平、公开、透明。
      </p>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name: "AssetRegister",

  data() {
    return {
      loading: false,
      submitted: false,
      status: -1,
      form: {
        name: "",
        id_card: "",
        made_asset: "",
        yunbo_asset: ""
      }
    };
  },

  computed: {
    statusText() {
      if (this.status === 1) return "审核通过";
      if (this.status === 2) return "审核未通过";
      return "审核中";
    }
  },

  created() {
    this.loadStatus();
  },

  methods: {
    unwrap(response) {
      if (response && response.code !== undefined) return response;
      return response && response.data ? response.data : response;
    },
    formatAmount(value) {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount.toFixed(2) : value || "0.00";
    },
    goHome() {
      this.$router.back();
    },
    async loadStatus() {
      try {
        const res = await request.get("/api/v1/user/assetStatus");
        const result = this.unwrap(res);
        const data = result && result.data ? result.data : null;
        if (!data || !data.submitted) {
          return;
        }
        this.submitted = true;
        this.status = Number(data.status);
        this.form.name = data.name || "";
        this.form.id_card = data.id_card || "";
        this.form.made_asset = data.made_asset || "";
        this.form.yunbo_asset = data.yunbo_asset || "";
      } catch (e) {
        // keep form when status cannot be loaded
      }
    },
    async submit() {
      if (!this.form.name) {
        this.$dialog.error("请输入姓名");
        return;
      }
      if (!this.form.id_card) {
        this.$dialog.error("请输入身份证号码");
        return;
      }
      if (String(this.form.id_card).length > 32) {
        this.$dialog.error("身份证号码过长");
        return;
      }
      if (String(this.form.name).length > 50) {
        this.$dialog.error("姓名过长");
        return;
      }
      if (!this.form.made_asset) {
        this.$dialog.error("请输入中国制造资产金额");
        return;
      }
      if (!this.form.yunbo_asset) {
        this.$dialog.error("请输入中华云泊资产金额");
        return;
      }
      if (Number(this.form.made_asset) > 1000000000) {
        this.$dialog.error("资产最高不能超过10亿元");
        return;
      }
      if (Number(this.form.yunbo_asset) > 1000000000) {
        this.$dialog.error("资产最高不能超过10亿元");
        return;
      }
      if (this.loading) {
        return;
      }

      this.loading = true;

      try {
        const res = await request.post("/api/v1/user/assetRegister", {
          name: this.form.name,
          id_card: this.form.id_card,
          made_asset: this.form.made_asset,
          yunbo_asset: this.form.yunbo_asset
        });
        this.loading = false;
        const result = this.unwrap(res);
        if (!result || result.code !== 200) {
          this.$dialog.error(
            result && result.msg ? result.msg : "提交失败，请稍后重试"
          );
          return;
        }
        this.submitted = true;
        this.status = 0;
          this.$dialog.success("绑定成功，已提交审核");
      } catch (e) {
        this.loading = false;
        const result =
          e && e.response && e.response.data ? e.response.data : null;
        this.$dialog.error(
          result && result.msg ? result.msg : "提交失败，请稍后重试"
        );
      }
    }
  }
};
</script>

<style scoped>
.asset-register {
  min-height: 100vh;
  background: linear-gradient(to bottom, #f5222d 0, #ff4d4f 90px, #fff1f0 250px);
  box-sizing: border-box;
}

.form-box {
  margin: 0 12px;
  padding: 8px 16px 18px;
  background: #fff;
  border-radius: 9px;
}

.form-item {
  min-height: 52px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

.form-item .label {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #222;
}

.form-item .value {
  min-width: 0;
  flex: 1;
  padding: 0 8px;
  color: #333;
  font-size: 13px;
  text-align: right;
  word-break: break-all;
}

.form-item input {
  min-width: 0;
  flex: 1;
  height: 52px;
  border: 0;
  outline: none;
  text-align: right;
  font-size: 13px;
  color: #333;
  background: transparent;
  padding: 0 8px;
  box-sizing: border-box;
}

.form-item input::placeholder {
  color: #c5c5c5;
}

.unit {
  color: #ff5722;
  font-size: 14px;
  flex-shrink: 0;
}

.submit-btn {
  width: 100%;
  height: 40px;
  margin-top: 14px;
  border: 0;
  border-radius: 22px;
  background: #ff4b0b;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.submit-btn--status {
  background: #f5222d;
  opacity: 1;
}

.submit-btn--status.van-button--disabled {
  opacity: 1;
  color: #fff;
}

.notice {
  padding: 10px 14px 30px;
  color: #333;
  font-size: 11px;
  line-height: 1.7;
}

.notice-title {
  color: #f5222d;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
}

.notice p {
  margin: 0 0 16px;
}
</style>
